import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { cartTotalDisplayStyles as styles } from "@waytek/Overrides/Components/CartTotalDisplay";
import { tooltip } from "@waytek/Utilities/styleguide";
import { colorStrings, mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

styles.container = {
    ...styles.container,
    css: css``,
};

styles.labelGridItem = {
    ...styles.labelGridItem,
    css: css`
        ${styles.labelGridItem?.css}
        &[hidden] {
            display: none;
        }

        ${TypographyStyle} {
            color: ${getColor(colorStrings.commonGlobalDarkerGray)};
            font-size: 18px;
            font-weight: 400;
            line-height: normal;
        }
    `,
};

styles.valueGridItem = {
    ...styles.valueGridItem,
    css: css`
        ${styles.valueGridItem?.css}
        &[hidden] {
            display: none;
        }

        ${TypographyStyle} {
            color: ${getColor(colorStrings.commonGlobalDarkerGray)};
            font-size: 18px;
            font-weight: 400;
            line-height: normal;
        }
    `,
};

styles.totalValue = {
    ...styles.totalValue,
    css: css`
        ${styles.totalValue?.css}
        &&${TypographyStyle} {
            font-size: 21px;
            line-height: 25px;
        }
    `,
};

styles.tooltip = {
    ...styles.tooltip,
    mergeCss: true,
    iconProps: {
        color: colorStrings.commonGlobalGuardianBlue,
    },
    cssOverrides: {
        tooltipWrapper: css`
            margin-left: 5px;
        `,
        tooltipContainer: css`
            ${tooltip.defaultProps?.cssOverrides?.tooltipContainer};

            ${mediaQueriesBP.maxMD} {
                margin-left: -75px;

                &::before {
                    left: 75px;
                }
                &::after {
                    left: 75px;
                }
            }
        `,
    },
};
